import React from "react";

const Dashboard = React.lazy(
  () => import("./views/kalasanPages/dashboard/Dashboard"),
);
const Outlet = React.lazy(
  () => import("./views/kalasanPages/master/outlet/Outlet"),
);
const Jabatan = React.lazy(
  () => import("./views/kalasanPages/master/jabatan/Jabatan"),
);
const Satuan = React.lazy(
  () => import("./views/kalasanPages/master/satuan/Satuan"),
);
const Rack = React.lazy(() => import("./views/kalasanPages/master/rak/Rack"));
const Printer = React.lazy(
  () => import("./views/kalasanPages/master/printer/Printer"),
);
const ManajemenRole = React.lazy(
  () => import("./views/kalasanPages/pengaturan/manajemenRole/ManajemenRole"),
);
const ManajemenMenu = React.lazy(
  () => import("./views/kalasanPages/pengaturan/manajemenMenu/ManajemenMenu"),
);
const ManajemenPengguna = React.lazy(
  () =>
    import("./views/kalasanPages/pengaturan/manajemenPengguna/ManajemenPengguna"),
);
const KonfigurasiUmum = React.lazy(
  () =>
    import("./views/kalasanPages/pengaturan/konfigurasiUmum/KonfigurasiUmum"),
);
const ManajemenHakAkses = React.lazy(
  () =>
    import("./views/kalasanPages/pengaturan/manajemenHakAkses/ManajemenHakAkses"),
);

const DataPerusahaan = React.lazy(
  () => import("./views/kalasanPages/pengaturan/dataPerusahaan/DataPerusahaan"),
);
const Pengumuman = React.lazy(
  () => import("./views/kalasanPages/pengaturan/pengumuman/Pengumuman"),
);
const AuditTrail = React.lazy(
  () => import("./views/kalasanPages/histori/auditTrail/AuditTrail"),
);
const Notifikasi = React.lazy(
  () => import("./views/kalasanPages/histori/notifikasi/Notifikasi"),
);
const Gudang = React.lazy(
  () => import("./views/kalasanPages/master/gudang/Gudang"),
);
const Supplier = React.lazy(
  () => import("./views/kalasanPages/master/supplier/Supplier"),
);
// const Pegawai = React.lazy(
//   () => import("./views/kalasanPages/master/pegawai/Pegawai"),
// );
const Customer = React.lazy(
  () => import("./views/kalasanPages/master/customer/Customer"),
);
const SOP = React.lazy(() => import("./views/kalasanPages/master/SOP/SOP"));
const RuanganMeja = React.lazy(
  () => import("./views/kalasanPages/master/ruanganMeja/RuanganMeja"),
);
const Produk = React.lazy(
  () => import("./views/kalasanPages/master/produk/Produk"),
);
const KodeAkun = React.lazy(
  () => import("./views/kalasanPages/master/kodeAkun/KodeAkun"),
);
const Divisi = React.lazy(
  () => import("./views/kalasanPages/master/divisi/Divisi"),
);
const PermintaanOwner = React.lazy(
  () =>
    import("./views/kalasanPages/inventory/permintaanOwner/PermintaanOwner"),
);
const PinjamanKaryawan = React.lazy(
  () => import("./views/kalasanPages/personalia/pinjaman/PinjamanKaryawan"),
);
const Chat = React.lazy(() => import("./views/kalasanPages/histori/chat/Chat"));
const Absensi = React.lazy(
  () => import("./views/kalasanPages/personalia/absensi/Absensi"),
);
const DaftarAbsensi = React.lazy(
  () => import("./views/kalasanPages/personalia/absensi/DaftarAbsensi"),
);
const LogAbsen = React.lazy(
  () => import("./views/kalasanPages/personalia/lihatAbsen/LihatAbsensi"),
);
const FormulaPayroll = React.lazy(
  () => import("./views/kalasanPages/personalia/formulaPayroll/FormulaPayroll"),
);
const Payroll = React.lazy(
  () => import("./views/kalasanPages/personalia/payroll/Payroll"),
);
const Pegawai = React.lazy(
  () => import("./views/kalasanPages/personalia/pegawai/Pegawai"),
);
const Shift = React.lazy(
  () => import("./views/kalasanPages/personalia/shift/ShiftNav"),
);
const MasterShift = React.lazy(
  () =>
    import("./views/kalasanPages/personalia/masterPersonalia/MasterPersonalia"),
);
const Cuti = React.lazy(
  () =>
    import("./views/kalasanPages/personalia/masterPersonalia/MasterPersonalia"),
);
const MasterSalaryNav = React.lazy(
  () =>
    import("./views/kalasanPages/personalia/masterPersonalia/MasterPersonalia"),
);
const SuratPeringatan = React.lazy(
  () =>
    import("./views/kalasanPages/personalia/suratPeringatan/SuratPeringatan"),
);
const PengajuanCuti = React.lazy(
  () => import("./views/kalasanPages/personalia/pengajuanCuti/PengajuanCuti"),
);
const PengajuanIzin = React.lazy(
  () => import("./views/kalasanPages/personalia/pengajuanIzin/PengajuanIzin"),
);
const PengajuanLembur = React.lazy(
  () =>
    import("./views/kalasanPages/personalia/pengajuanLembur/PengajuanLembur"),
);
const PermintaanPusat = React.lazy(
  () =>
    import("./views/kalasanPages/permintaan/permintaanPusat/PermintaanPusat"),
);
const PermintaanDivisi = React.lazy(
  () =>
    import("./views/kalasanPages/permintaan/permintaanDivisi/PermintaanDivisi"),
);
const RekapPermintaanDivisi = React.lazy(
  () =>
    import("./views/kalasanPages/permintaan/rekapPermintaanDivisi/RekapPermintaanDivisi"),
);
const PermintaanBarangPajak = React.lazy(
  () =>
    import("./views/kalasanPages/permintaan/permintaanBarangPajak/PermintaanBarangPajak"),
);
const RekapPermintaanPusat = React.lazy(
  () =>
    import("./views/kalasanPages/permintaan/rekapPermintaanPusat/RekapPermintaanPusat"),
);
const PermintaanReservasiPaket = React.lazy(
  () =>
    import("./views/kalasanPages/permintaan/permintaanReservasiPaket/PermintaanReservasiPaket"),
);
const RekapPermintaan = React.lazy(
  () =>
    import("./views/kalasanPages/pembelian/rekapPermintaan/RekapPermintaan"),
);
const RekapPermintaanBarangPajak = React.lazy(
  () =>
    import("./views/kalasanPages/pembelian/rekapPermintaanBarangPajak/RekapPermintaanBarangPajak"),
);
const DaftarPembelian = React.lazy(
  () =>
    import("./views/kalasanPages/pembelian/daftarPembelian/DaftarPembelian"),
);
const DaftarPO = React.lazy(
  () => import("./views/kalasanPages/pembelian/daftarPO/DaftarPO"),
);
const RekapHargaBeli = React.lazy(
  () => import("./views/kalasanPages/dashboard/rekapHargaBeli/RekapHargaBeli"),
);
const RekapKirimBarang = React.lazy(
  () =>
    import("./views/kalasanPages/dashboard/rekapKirimBarang/RekapKirimBarang"),
);
const OrderBarang = React.lazy(
  () => import("./views/kalasanPages/dashboard/orderBarang/OrderBarang"),
);
const Container = React.lazy(
  () => import("./views/kalasanPages/inventory/container/Container"),
);
const Kolam = React.lazy(
  () => import("./views/kalasanPages/inventory/kolam/Kolam"),
);
const StockOpname = React.lazy(
  () => import("./views/kalasanPages/inventory/stockOpname/StockOpname"),
);
const RekapPermintaanGudang = React.lazy(
  () =>
    import("./views/kalasanPages/inventory/rekapPermintaanGudang/RekapPermintaanGudang"),
);
const DetailRekapPermintaanGudang = React.lazy(
  () =>
    import("./views/kalasanPages/inventory/detailRekapPermintaanGudang/DetailRekapPermintaanGudang"),
);
const LihatStok = React.lazy(
  () => import("./views/kalasanPages/inventory/lihatStok/LihatStok"),
);
const StokExpired = React.lazy(
  () => import("./views/kalasanPages/inventory/stokExpired/StokExpired"),
);
const Stokin = React.lazy(
  () => import("./views/kalasanPages/inventory/stokMasuk/StockIn"),
);
const StockOut = React.lazy(
  () => import("./views/kalasanPages/inventory/stokKeluar/StockOut"),
);
const PenyesuaianStok = React.lazy(
  () =>
    import("./views/kalasanPages/inventory/penyesuaianStok/PenyesuaianStok"),
);
const MutasiBarang = React.lazy(
  () => import("./views/kalasanPages/inventory/mutasiBarang/MutasiBarang"),
);
const PermintaanBarang = React.lazy(
  () =>
    import("./views/kalasanPages/inventory/permintaanBarang/PermintaanBarang"),
);
const PengirimanBarang = React.lazy(
  () =>
    import("./views/kalasanPages/inventory/pengirimanBarang/PengirimanBarang"),
);
const PenerimaanBarang = React.lazy(
  () =>
    import("./views/kalasanPages/inventory/penerimaanBarang/PenerimaanBarang"),
);
const Asset = React.lazy(
  () => import("./views/kalasanPages/inventory/asset/Asset"),
);
const PinjamBarang = React.lazy(
  () => import("./views/kalasanPages/inventory/pinjamBarang/PinjamBarang"),
);
const Kitchen = React.lazy(
  () => import("./views/kalasanPages/penjualan/kitchen/Kitchen"),
);
// const DapurTengah = React.lazy(() =>
//   import("./views/kalasanPages/penjualan/dapurTengah/DapurTengah")
// );
// const Waitress = React.lazy(() =>
//   import("./views/kalasanPages/penjualan/waitress/Waitress")
// );
// const WaitressOnGoing = React.lazy(() =>
//   import("./views/kalasanPages/penjualan/waitress/OnGoing")
// );
// const WaitressStatus = React.lazy(() =>
//   import("./views/kalasanPages/penjualan/waitress/Status")
// );
const DaftarMenu = React.lazy(
  () => import("./views/kalasanPages/penjualan/daftarmenu/DaftarMenu"),
);
const Diskon = React.lazy(
  () => import("./views/kalasanPages/penjualan/diskon/Diskon"),
);
const KategoriMenu = React.lazy(
  () => import("./views/kalasanPages/penjualan/kategorimenu/KategoriMenu"),
);
// const Kasir = React.lazy(() =>
//   import("./views/kalasanPages/penjualan/kasir/Kasir")
// );
// const Kasir = React.lazy(() =>
//   import("./views/kalasanPages/penjualan/kasir/KasirRevamp")
// );
// const Kasir = React.lazy(() =>
//   import("./views/kalasanPages/penjualan/kasir/KasirRevamp3")
// );
const Reservasi = React.lazy(
  () => import("./views/kalasanPages/penjualan/reservasi/Reservasi"),
);

const ReservasiPackage = React.lazy(
  () =>
    import("./views/kalasanPages/penjualan/reservasiPackage/ReservasiPackage"),
);
const Package = React.lazy(
  () => import("./views/kalasanPages/penjualan/package/Package"),
);
const PaymentLoan = React.lazy(
  () =>
    import("./views/kalasanPages/personalia/riwayatPinjaman/RiwayatPinjaman"),
);
const ProsesPermintaan = React.lazy(
  () =>
    import("./views/kalasanPages/inventory/prosesPermintaan/ProsesPermintaan"),
);
const Task = React.lazy(
  () => import("./views/kalasanPages/personalia/task/Task"),
);
const SalesReport = React.lazy(
  () => import("./views/kalasanPages/penjualan/report/LaporanPenjualan"),
);

// Laporan
const MainSalesReport = React.lazy(
  () =>
    import("./views/kalasanPages/laporan/penjualan-pusat/ListLaporanPenjualanPusat"),
);
const PurchasementReport = React.lazy(
  () => import("./views/kalasanPages/laporan/pembelian/ListLaporanPembelian"),
);
const RekapPO = React.lazy(
  () => import("./views/kalasanPages/laporan/pembelian/RekapPO"),
);
const StockReport = React.lazy(
  () => import("./views/kalasanPages/laporan/stok/ListLaporanStok"),
);
const OperationalReport = React.lazy(
  () => import("./views/kalasanPages/penjualan/report/LaporanOperasional"),
);
const CancellationReport = React.lazy(
  () => import("./views/kalasanPages/penjualan/report/LaporanPembatalan"),
);
const Panjar = React.lazy(
  () => import("./views/kalasanPages/penjualan/report/Panjar"),
);
const ReportRefund = React.lazy(
  () => import("./views/kalasanPages/penjualan/report/LaporanRefund"),
);
const Feedback = React.lazy(
  () => import("./views/kalasanPages/personalia/feedback/EmployeeFeedback"),
);
const ProdukJasa = React.lazy(
  () => import("./views/kalasanPages/master/produkJasa/ProdukJasa"),
);
const MejaAktif = React.lazy(
  () => import("./views/kalasanPages/penjualan/report/MejaAktif"),
);
const PenjualanProdukJasa = React.lazy(
  () =>
    import("./views/kalasanPages/penjualan/penjualanProdukJasa/PenjualanProdukJasa"),
);
const KonversiReservasiPaket = React.lazy(
  () =>
    import("./views/kalasanPages/penjualan/konversiReservasiPaket/KonversiReservasiPaket"),
);
const DetailLaporanPenjualan = React.lazy(
  () =>
    import("./views/kalasanPages/penjualan/report/reportComponents/LaporanPenjualanKredit"),
);
const RekapPenjualan = React.lazy(
  () => import("./views/kalasanPages/penjualan/report/RekapPenjualan"),
);
const RekapPenjualanNoPrice = React.lazy(
  () => import("./views/kalasanPages/penjualan/report/RekapPenjualanNoPrice"),
);
const RekapFastFood = React.lazy(
  () => import("./views/kalasanPages/penjualan/report/RekapFastFood"),
);
const LaporanPerubahanHarga = React.lazy(
  () => import("./views/kalasanPages/penjualan/report/LaporanPerubahanHarga"),
);
const MaintenanceRequest = React.lazy(
  () =>
    import("./views/kalasanPages/teknisi/maintenanceRequest/MaintenanceRequest"),
);
const UserMaintenanceRequest = React.lazy(
  () =>
    import("./views/kalasanPages/teknisi/maintenanceRequest/UserMaintenanceRequest"),
);
const DaftarSPK = React.lazy(
  () => import("./views/kalasanPages/produksi/SPK/SPKNav"),
);
const DaftarBOM = React.lazy(
  () => import("./views/kalasanPages/produksi/BOM/DaftarBOM"),
);
const DaftarProduksi = React.lazy(
  () => import("./views/kalasanPages/produksi/daftarProduksi/ProduksiNav"),
);
const SayurKaryawan = React.lazy(
  () => import("./views/kalasanPages/produksi/sayurKaryawan/SayurKaryawan"),
);
const CalculatorProduksi = React.lazy(
  () =>
    import("./views/kalasanPages/produksi/calculatorProduksi/calculatorProduksi"),
);
const DaftarPenyiapanBahan = React.lazy(
  () =>
    import("./views/kalasanPages/produksi/penyiapanBahan/DaftarPenyiapanBahan"),
);
const RekapProduksi = React.lazy(
  () => import("./views/kalasanPages/dashboard/rekapProduksi/RekapProduksi"),
);
const SettingTimbangan = React.lazy(
  () => import("./views/kalasanPages/pengaturan/timbangan/SettingTimbangan"),
);
const MutasiGudang = React.lazy(
  () => import("./views/kalasanPages/inventory/mutasiGudang/MutasiGudang"),
);
const PembuatanSuratJalan = React.lazy(
  () =>
    import("./views/kalasanPages/pengiriman/pembuatanSuratJalan/PembuatanSuratJalan"),
);
const CeklisPengiriman = React.lazy(
  () =>
    import("./views/kalasanPages/pengiriman/pengirimanBarang/CeklisPengiriman"),
);

const ListBarangHilang = React.lazy(
  () => import("./views/kalasanPages/pengiriman/barangHilang/listBarangHilang"),
);
const PenerimaanCabang = React.lazy(
  () =>
    import("./views/kalasanPages/pengiriman/penerimaanBarang/PenerimaanCabang"),
);
const PengembalianBarang = React.lazy(
  () =>
    import("./views/kalasanPages/pengiriman/pengembalianBarang/PengembalianBarang"),
);
const DaftarTagihan = React.lazy(
  () => import("./views/kalasanPages/tagihan/daftarTagihan/DaftarTagihan"),
);
const DaftarPembayaran = React.lazy(
  () =>
    import("./views/kalasanPages/tagihan/daftarPembayaran/DaftarPembayaran"),
);
const JurnalTransaksi = React.lazy(
  () =>
    import("./views/kalasanPages/pembelian/jurnalTransaksi/JurnalTransaksi"),
);

const routes = [
  { path: "/", exact: true, name: "Home" },
  { path: "/dashboard", name: "Dashboard", component: Dashboard },
  {
    path: "/master/position",
    name: "Jabatan",
    component: Jabatan,
  },
  {
    path: "/master/unit",
    name: "Satuan",
    component: Satuan,
  },
  {
    path: "/master/rack",
    name: "Keranjang",
    component: Rack,
  },
  {
    path: "/master/warehouse",
    name: "Gudang",
    component: Gudang,
  },
  {
    path: "/master/supplier",
    name: "Supplier",
    component: Supplier,
  },
  // {
  //   path: "/master/employee",
  //   name: "Pegawai",
  //   component: Pegawai,
  // },
  {
    path: "/master/product",
    name: "Produk",
    component: Produk,
  },
  {
    path: "/pengaturan/room",
    name: "Ruangan Meja",
    component: RuanganMeja,
  },
  {
    path: "/master/customer",
    name: "Customer",
    component: Customer,
  },
  {
    path: "/master/sop",
    name: "SOP",
    component: SOP,
  },
  {
    path: "/master/role",
    name: "Manajemen Role",
    component: ManajemenRole,
  },
  {
    path: "/master/product-service",
    name: "Produk & Jasa",
    component: ProdukJasa,
  },
  {
    path: "/pengaturan/printer",
    name: "Printer",
    component: Printer,
  },
  {
    path: "/pengaturan/timbangan",
    name: "Timbangan",
    component: SettingTimbangan,
  },
  {
    path: "/pengaturan/manajemen-menu",
    name: "Manajemen Menu",
    component: ManajemenMenu,
  },
  {
    path: "/pengaturan/account",
    name: "Manajemen Pengguna",
    component: ManajemenPengguna,
  },
  {
    path: "/pengaturan/company",
    name: "Data Perusahaan",
    component: DataPerusahaan,
  },
  {
    path: "/pengaturan/manajemen-hak-akses",
    name: "Manajemen Hak Akses",
    component: ManajemenHakAkses,
  },
  {
    path: "/pengaturan/konfigurasi-umum",
    name: "Konfigurasi Umum",
    component: KonfigurasiUmum,
  },
  {
    path: "/pengaturan/pengumuman",
    name: "Pengumuman",
    component: Pengumuman,
  },
  {
    path: "/history/audit-trail",
    name: "Audit Trail",
    component: AuditTrail,
  },
  {
    path: "/history/notifikasi",
    name: "Notifikasi",
    component: Notifikasi,
  },
  {
    path: "/master/outlet",
    name: "Outlet",
    component: Outlet,
  },
  {
    path: "/master/coa",
    name: "Kode Akun",
    component: KodeAkun,
  },
  {
    path: "/master/division",
    name: "Divisi",
    component: Divisi,
  },
  {
    path: "/permintaan/pusat",
    name: "Permintaan Pusat",
    component: PermintaanPusat,
  },
  {
    path: "/permintaan/cabang",
    name: "Permintaan Cabang",
    component: PermintaanDivisi,
  },
  {
    path: "/permintaan/rekap-cabang",
    name: "Rekap Permintaan Cabang",
    component: RekapPermintaanDivisi,
  },
  {
    path: "/permintaan/barang-pajak",
    name: "Permintaan Barang Pajak",
    component: PermintaanBarangPajak,
  },
  {
    path: "/permintaan/rekap-pusat",
    name: "Rekap Permintaan Pusat",
    component: RekapPermintaanPusat,
  },
  {
    path: "/permintaan/reservasi-paket",
    name: "Permintaan Reservasi Paket",
    component: PermintaanReservasiPaket,
  },
  {
    path: "/hr/loan",
    name: "Pinjaman Karyawan",
    component: PinjamanKaryawan,
  },
  {
    path: "/hr/task",
    name: "Task Management",
    component: Task,
  },
  {
    path: "/history/chat",
    name: "Penerimaan Pembelian",
    component: Chat,
  },
  {
    path: "/hr/attendance",
    name: "Absensi",
    component: Absensi,
  },
  {
    path: "/hr/report",
    name: "Lihat Absensi",
    component: LogAbsen,
  },
  {
    path: "/hr/paymentLoan",
    name: "Absensi",
    component: PaymentLoan,
  },
  {
    path: "/hr/payroll_formula",
    name: "Formula Payroll",
    component: FormulaPayroll,
  },
  {
    path: "/hr/payroll",
    name: "Payroll",
    component: Payroll,
  },
  {
    path: "/purchase/grouping",
    name: "Rekap Permintaan Pembelian",
    component: RekapPermintaan,
  },
  {
    path: "/purchase/grouping-tax",
    name: "Rekap Permintaan B. Pajak",
    component: RekapPermintaanBarangPajak,
  },
  {
    path: "/purchase/list",
    name: "Daftar Pembelian",
    component: DaftarPembelian,
  },
  {
    path: "/purchase/order",
    name: "Daftar PO",
    component: DaftarPO,
  },
  {
    path: "/purchase/journal",
    name: "Jurnal Transaksi",
    component: JurnalTransaksi,
  },
  {
    path: "/pembelian/rekap-harga-beli",
    name: "Rekap Harga Beli",
    component: RekapHargaBeli,
  },
  {
    path: "/laporan/rekap-po",
    name: "Laporan Rekap PO Produk",
    component: RekapPO,
  },
  {
    path: "/gudang/kirim-barang",
    name: "Rekap Kirim Barang",
    component: RekapKirimBarang,
  },
  {
    path: "/produksi/order-produk",
    name: "Order Barang",
    component: OrderBarang,
  },
  {
    path: "/delivery/delivery-note",
    name: "Pembuatan Surat Jalan",
    component: PembuatanSuratJalan,
  },
  {
    path: "/delivery/delivery-checklist",
    name: "Ceklis Pengiriman",
    component: CeklisPengiriman,
  },
  {
    path: "/delivery/delivery-missing",
    name: "Barang Hilang",
    component: ListBarangHilang,
  },
  {
    path: "/delivery/delivery-receive",
    name: "Penerimaan Cabang",
    component: PenerimaanCabang,
  },
  {
    path: "/delivery/retur-product",
    name: "Pengembalian Barang",
    component: PengembalianBarang,
  },
  {
    path: "/tagihan/list",
    name: "Daftar Tagihan",
    component: DaftarTagihan,
  },
  {
    path: "/tagihan/payment",
    name: "Daftar Pembayaran",
    component: DaftarPembayaran,
  },
  {
    path: "/production/list",
    name: "Daftar Produksi",
    component: DaftarProduksi,
  },
  {
    path: "/production/employee-catering",
    name: "Sayur Karyawan",
    component: SayurKaryawan,
  },
  {
    path: "/produksi/rekap",
    name: "Rekap Produksi",
    component: RekapProduksi,
  },
  {
    path: "/calculator",
    name: "Calculator Produksi",
    component: CalculatorProduksi,
  },
  {
    path: "/production/preparation",
    name: "Penyiapan Bahan",
    component: DaftarPenyiapanBahan,
  },
  {
    path: "/production/spk",
    name: "Daftar SPK",
    component: DaftarSPK,
  },
  {
    path: "/production/bom",
    name: "Daftar BOM",
    component: DaftarBOM,
  },
  {
    path: "/inventory/owner",
    name: "Permintaan Owner",
    component: PermintaanOwner,
  },
  {
    path: "/inventory/asset",
    name: "Aset & Inventaris",
    component: Asset,
  },
  {
    path: "/inventory/container",
    name: "Container",
    component: Container,
  },
  {
    path: "/inventory/pool",
    name: "Kolam",
    component: Kolam,
  },
  {
    path: "/inventory/stok",
    name: "Stok",
    component: LihatStok,
  },
  {
    path: "/inventory/stok-opname",
    name: "Stok Opname",
    component: StockOpname,
  },
  {
    path: "/inventory/rekap-permintaan",
    name: "Rekap Permintaan Gudang",
    component: RekapPermintaanGudang,
  },
  {
    path: "/inventory/detail-rekap-permintaan",
    name: "Detail Rekap Permintaan Gudang",
    component: DetailRekapPermintaanGudang,
  },
  {
    path: "/inventory/stokin",
    name: "Stok Masuk",
    component: Stokin,
  },
  {
    path: "/inventory/stokout",
    name: "Stok Keluar",
    component: StockOut,
  },
  {
    path: "/inventory/stokexpired",
    name: "Stok Expired",
    component: StokExpired,
  },
  {
    path: "/inventory/adjustment",
    name: "Penyesuaian Stok",
    component: PenyesuaianStok,
  },
  {
    path: "/inventory/mutasi-gudang",
    name: "Mutasi Gudang Sesama Outlet",
    component: MutasiGudang,
  },
  {
    path: "/inventory/request",
    name: "Permintaan Barang",
    component: PermintaanBarang,
  },
  {
    path: "/inventory/delivery",
    name: "Pengiriman Barang",
    component: PengirimanBarang,
  },
  {
    path: "/inventory/receiptorder",
    name: "Penerimaan Barang",
    component: PenerimaanBarang,
  },
  {
    path: "/inventory/pinjam-barang",
    name: "Pinjam Barang",
    component: PinjamBarang,
  },
  {
    path: "/sales/product-service",
    name: "Penjualan Produk & Jasa",
    component: PenjualanProdukJasa,
  },
  // {
  //   path: "/sales/order",
  //   exact: true,
  //   name: "Waitress",
  //   component: Waitress,
  // },
  // {
  //   path: "/sales/order/on-going",
  //   exact: true,
  //   name: "Waitress On Going",
  //   component: WaitressOnGoing,
  // },
  // {
  //   path: "/sales/order/status",
  //   exact: true,
  //   name: "Waitress Status",
  //   component: WaitressStatus,
  // },
  {
    path: "/sales/discount",
    name: "Discount",
    component: Diskon,
  },
  {
    path: "/sales/order-menu",
    name: "Daftar Menu",
    component: DaftarMenu,
  },
  {
    path: "/sales/categories-menu",
    name: "Kategori Menu",
    component: KategoriMenu,
  },
  {
    path: "/sales/list",
    name: "Waitress",
    component: Kitchen,
  },
  // {
  //   path: "/sales/mid-kitchen",
  //   name: "Dapur Tengah",
  //   component: DapurTengah,
  // },
  // {
  //   path: "/sales/cashier",
  //   name: "Kasir",
  //   component: Kasir,
  // },
  {
    path: "/sales/reservasi",
    name: "Reservasi",
    component: Reservasi,
  },
  {
    path: "/sales/reservasi-paket",
    name: "Reservasi Package",
    component: ReservasiPackage,
  },
  {
    path: "/sales/konversi-reservasi-paket",
    name: "Konversi Reservasi Paket",
    component: KonversiReservasiPaket,
  },
  {
    path: "/sales/package",
    name: "Package",
    component: Package,
  },
  {
    path: "/inventory/process",
    name: "Proses Permintaan",
    component: ProsesPermintaan,
  },
  {
    path: "/report/sales",
    name: "Laporan Penjualan",
    component: SalesReport,
  },
  {
    path: "/report/sales-pusat",
    name: "Laporan Penjualan Pusat",
    component: MainSalesReport,
  },
  {
    path: "/report/purchasement",
    name: "Laporan Pembelian Pusat",
    component: PurchasementReport,
  },
  {
    path: "/report/stock",
    name: "Laporan Stok",
    component: StockReport,
  },
  {
    path: "/report/operational",
    name: "Laporan Operasional",
    component: OperationalReport,
  },

  {
    path: "/report/cancel-menu",
    name: "Laporan Pembatalan Menu",
    component: CancellationReport,
  },
  {
    path: "/report/panjar",
    name: "Panjar",
    component: Panjar,
  },
  {
    path: "/report/refund",
    name: "Laporan Refund",
    component: ReportRefund,
  },
  {
    path: "/report/meja-aktif",
    name: "Meja Aktif",
    component: MejaAktif,
  },
  {
    path: "/hr/employeeFeedback",
    name: "Kritik dan Saran",
    component: Feedback,
  },

  // PERSONALIA
  {
    path: "/personalia/absensi",
    name: "Absensi",
    component: Absensi,
  },
  {
    path: "/personalia/daftar-absensi",
    name: "Daftar Absensi",
    component: DaftarAbsensi,
  },
  {
    path: "/personalia/lihat-absensi",
    name: "Lihat Absensi",
    component: LogAbsen,
  },
  {
    path: "/personalia/formula-payroll",
    name: "Formula Payroll",
    component: FormulaPayroll,
  },
  {
    path: "/personalia/payroll",
    name: "Payroll",
    component: Payroll,
  },
  {
    path: "/personalia/pinjaman-karyawan",
    name: "Pinjaman Karyawan",
    component: PinjamanKaryawan,
  },
  {
    path: "/personalia/riwayat-pinjaman",
    name: "Riwayat Pinjaman",
    component: PaymentLoan,
  },
  {
    path: "/personalia/detail-karyawan",
    name: "Pegawai",
    component: Pegawai,
  },
  {
    path: "/personalia/master-shift",
    name: "Master Shift",
    component: MasterShift,
  },
  {
    path: "/personalia/master-salary",
    name: "Master Salary",
    component: MasterSalaryNav,
  },
  {
    path: "/personalia/shift-karyawan",
    name: "Shift",
    component: Shift,
  },
  {
    path: "/personalia/cuti-karyawan",
    name: "Cuti",
    component: Cuti,
  },
  {
    path: "/personalia/surat-peringatan",
    name: "Surat Peringatan",
    component: SuratPeringatan,
  },
  {
    path: "/hr/cuti",
    name: "Pengajuan Cuti",
    component: PengajuanCuti,
  },
  {
    path: "/profile/cuti",
    name: "Pengajuan Cuti",
    component: PengajuanCuti,
  },
  {
    path: "/hr/izin",
    name: "Pengajuan Izin",
    component: PengajuanIzin,
  },
  {
    path: "/hr/lembur",
    name: "Pengajuan Lembur",
    component: PengajuanLembur,
  },
  {
    path: "/profile/izin",
    name: "Pengajuan Izin",
    component: PengajuanIzin,
  },
  {
    path: "/profile/lembur",
    name: "Pengajuan Lembur",
    component: PengajuanLembur,
  },
  {
    path: "/report/detail-report-kas",
    name: "Detail Laporan Penjualan",
    component: DetailLaporanPenjualan,
  },
  {
    path: "/report/rekap-penjualan",
    name: "Rekap Penjualan",
    component: RekapPenjualan,
  },
  {
    path: "/report/rekap-penjualan-no-price",
    name: "Rekap Penjualan No Price",
    component: RekapPenjualanNoPrice,
  },
  {
    path: "/report/rekap-fastfood",
    name: "Rekap Fast Food",
    component: RekapFastFood,
  },
  {
    path: "/report/perubahan-harga",
    name: "Laporan Perubahan Harga",
    component: LaporanPerubahanHarga,
  },
  {
    path: "/maintenance-request",
    name: "Maintanance Request",
    component: UserMaintenanceRequest,
  },
  {
    path: "/teknisi/maintenance-request",
    name: "Teknisi Maintanance",
    component: MaintenanceRequest,
  },
];

export default routes;
